<template>
    <div class="app-container">
        <navBar :title="'公告详情'" @handleGoBack="handleGoBack">
            <template v-slot:icon1 v-if="this.$auth.hasPermi('oa:notice:del')">
                <van-icon name="delete" size="20" class="mrg-r-20" @click="handleDelete"/>
            </template>
        </navBar>

        <div class="item-tab">
            <div class="title-wrap">
                <div class="flex-spa-ver-cen">
                    <div class="tit over_hidden">{{ detailObj.noticeTitle || '--' }}</div>
                </div>
                <div class="flex">
                    <div>
                        <van-image
                                round
                                width="1.2rem"
                                height="1.2rem"
                                :src="detailObj.avatar"
                        />
                    </div>
                    <div>
                        <div class="time">{{ detailObj.createBy || '--' }}</div>
                        <div class="time">{{ detailObj.createTime || '--' }}</div>
                    </div>
                </div>
            </div>

            <div class="con">
                <div class="desc-wrap flex">
                    <div v-html="detailObj.noticeContent"></div>
                </div>
            </div>

            <AppendixVue :businessType="'oa_notice'" :needUpload="false"/>
        </div>
    </div>
</template>

<script>
    import {refernotice, delnotice} from "@/api/oa/notice";
    import AppendixVue from '@/views/components/crm/Appendix.vue';

    export default {
        components: {AppendixVue},
        data() {
            return {
                activeName: 'a',
                dataId: this.$route.query.id,
                detailObj: {}
            };
        },

        mounted() {
            this.getDetail();
        },

        methods: {
            handleGoBack() {
                this.$router.replace('/oa/oaNotice');
                this.$router.go(-1)
            },

            async getDetail() {
                const result = await refernotice(this.dataId);
                const {data = {}} = result;
                this.detailObj = data;
            },

            //删除
            handleDelete() {
                let that = this
                this.$dialog.confirm({
                    message: '是否确认删除',
                    width: '80%'
                })
                    .then(async () => {
                        // on confirm
                        await delnotice(that.dataId);
                        await that.handleGoBack();
                        that.$toast.fail('删除成功');

                    })
                    .catch(() => {
                    });
            }
        }

    };
</script>

<style lang="scss" scoped>
  .item-tab {
    background: #fff;
    padding: 0 33px;
    margin-top: 20px;

    .title-wrap {
      padding: 26px 0;

      .tit {
        font-size: 32px;
        font-weight: bold;
        color: #111111;
        width: 0;
        flex: 1;
        margin-top: 10px;
        margin-bottom: 30px;
      }

      .time {
        font-size: 24px;
        margin-top: 10px;
        margin-left: 20px;
        color: #999999;
      }
    }

    .con {
      padding: 30px 0;
      border-top: 1px solid #f3f3f3;
      border-bottom: 1px solid #f3f3f3;

      .desc-wrap {
        font-size: 28px;
        margin-bottom: 30px;

        .label {
          color: #999;
        }

        .value {
          color: #111;
        }

        .red {
          color: #f7ad00;
        }
      }

      .desc-wrap:last-child {
        margin-bottom: 0;
      }
    }
  }

  ::v-deep .van-tabs--line .van-tabs__wrap {
    height: 80px !important;
  }

  ::v-deep .van-tab {
    // padding: 40px 0;
    height: 80px !important;
    line-height: 80px !important;
    padding-bottom: 0 !important;
  }
</style>
